import React, { useContext } from "react"
import { availableLocales } from "./locales"
import { FormattedMessage } from "react-intl"
import { Select } from "antd"
import { LanguageContext } from "./LanguageContext"

const languages = availableLocales.map((locale) => {

  return {
    value: locale.languageCode,
    label: (
      <>
        <span style={{margin: '2px 5px 0 0'}}>
          {locale.icon}
        </span>
        <FormattedMessage description={locale.languageName.props.description} id={locale.languageName.props.id} />
      </>
    )
  }
})

export const LanguageSwitcher = () => {
  const { language, setLanguage } = useContext(LanguageContext)

  return (<Select
    defaultValue={language}
    style={{ width: '10em'}}
    onChange={(value) => setLanguage(value)}
    options={languages}
  />
  )
}